import {
  DELETE_DOCUMENT_MUTATION,
  GET_DOCUMENTS_LIST_QUERY,
  GET_STORAGE_INFO_QUERY,
  UPLOAD_DOCUMENT_AND_GET_PRESIGNED_URL_MUTATION,
} from './operations'
import type { DocumentsMutationsMap, DocumentsQueriesMap } from './types'

export const DOCUMENTS_QUERIES: DocumentsQueriesMap = {
  getDocumentsList: GET_DOCUMENTS_LIST_QUERY,
  getStorageInfo: GET_STORAGE_INFO_QUERY,
}

export const DOCUMENTS_MUTATIONS: DocumentsMutationsMap = {
  uploadDocumentAndGetPresignedUrl: UPLOAD_DOCUMENT_AND_GET_PRESIGNED_URL_MUTATION,
  deleteDocument: DELETE_DOCUMENT_MUTATION,
}
